import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import { LoadingMask } from '@jove-frontend/uikit';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ModalPlain = function ModalPlain(_ref) {
  var title = _ref.title,
      isOpen = _ref.isOpen,
      className = _ref.className,
      maxWidth = _ref.maxWidth,
      isLoading = _ref.isLoading,
      children = _ref.children,
      onClose = _ref.onClose;
  return /*#__PURE__*/_jsx(Transition, {
    appear: true,
    show: isOpen,
    as: Fragment,
    children: /*#__PURE__*/_jsxs(Dialog, {
      as: "div",
      className: "prose fixed inset-0 z-50 overflow-y-auto",
      onClose: onClose,
      children: [/*#__PURE__*/_jsx(Dialog.Overlay, {
        className: "fixed inset-0 bg-black opacity-50"
      }), /*#__PURE__*/_jsxs("div", {
        className: "min-h-screen text-center sm:px-4",
        children: [/*#__PURE__*/_jsx(Transition.Child, {
          as: Fragment,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /*#__PURE__*/_jsx(Dialog.Overlay, {
            className: "fixed inset-0"
          })
        }), /*#__PURE__*/_jsx("span", {
          className: "inline-block h-screen align-middle",
          "aria-hidden": "true",
          children: "\u200B"
        }), /*#__PURE__*/_jsx(Transition.Child, {
          as: Fragment,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 scale-95",
          enterTo: "opacity-100 scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 scale-100",
          leaveTo: "opacity-0 scale-95",
          children: /*#__PURE__*/_jsxs("div", {
            className: clsx('modal relative inline-block w-full transform rounded-lg bg-white text-left align-middle shadow-xl transition-all sm:my-8 dark:border dark:border-neutral-600 dark:bg-slate-900', maxWidth ? "max-w-".concat(maxWidth) : 'sm:max-w-xl', className),
            children: [/*#__PURE__*/_jsxs("header", {
              className: "flex items-center justify-between border-b border-black/10 px-5 py-4",
              children: [/*#__PURE__*/_jsx(Dialog.Title, {
                as: "p",
                className: "text-lg font-bold",
                children: title
              }), /*#__PURE__*/_jsxs("button", {
                type: "button",
                className: "text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-transparent focus:ring-offset-2",
                onClick: onClose,
                children: [/*#__PURE__*/_jsx("span", {
                  className: "sr-only",
                  children: "Close"
                }), /*#__PURE__*/_jsx(XIcon, {
                  className: "h-6 w-6",
                  "aria-hidden": "true"
                })]
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "p-5",
              children: children
            }), isLoading && /*#__PURE__*/_jsx(LoadingMask, {})]
          })
        })]
      })]
    })
  });
};